
import './Modal.css';
import React, { useEffect, useRef, useCallback } from 'react';
function Modal({ children, name = 'default', onClose, id, modalClass = 'modal', autoClose = true, autoCloseChangePageOnly = true, style, closeTimer = 300 }) {
    const ref = useRef();

    const onClick = (event) => {
        if (autoCloseChangePageOnly == false) {// les modales "normales" quand on clic en dehors d'elles doivent se fermer
            if (ref.current && ref.current.contains(event.target) == false && document.querySelectorAll('[id^="_nice_modal"]').length == 1) {
                onClose();
                return;
            }
        }
        if (autoClose == false || event.target.id != id) {
            return null;
        };
        onClose();
    }
    useEffect(() => {
        if (autoClose) {
            document.addEventListener("mousedown", onClick);
        }
        return () => {
            document.removeEventListener("mousedown", onClick);
        };
    }, [autoClose, autoCloseChangePageOnly]);

    useEffect(() => {
        const currentPath = window.location.pathname;

        const interval = setInterval(() => {
            if (window.location.pathname !== currentPath) {
                onClose();
            }
        }, 200);

        return () => clearInterval(interval);
    }, []);
    return (
        <div id={id} ref={ref} className={modalClass + " " + name} onMouseDown={onClick}>
            <div className={"modal-container " + name} style={style}>
                <div className="modal-info flex-column">
                    {children}
                </div>
            </div>
        </div>
    );
}

export default Modal;